import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import { PictureIcon, CaptionText } from '@paypalcorp/pp-react';

function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends$1.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutProperties$1(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose$1(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose$1(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function r(e) {
  var t,
    f,
    n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;else if ("object" == _typeof(e)) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length;) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".styles-module_image_preview_holder__52K-l {\n  background-color: #e6e0d9;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.styles-module_image_icon_holder__DBav7 {\n  color: #545d68;\n}\n.styles-module_image_text_holder__NAV4B {\n  margin-left: 12px;\n}\n.styles-module_rounded_corners__gqHUh {\n  border-radius: 12px 12px 0px 0px;\n}\n";
var styles = {"image_preview_holder":"styles-module_image_preview_holder__52K-l","image_icon_holder":"styles-module_image_icon_holder__DBav7","image_text_holder":"styles-module_image_text_holder__NAV4B","rounded_corners":"styles-module_rounded_corners__gqHUh"};
styleInject(css_248z);

var _excluded$1 = ["src", "content", "ariaHidden", "roundedCorners", "displayIcon"];
var Image = function Image(_ref) {
  var _ref$src = _ref.src,
    src = _ref$src === void 0 ? '' : _ref$src,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? {
      holderText: ''
    } : _ref$content,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    _ref$roundedCorners = _ref.roundedCorners,
    roundedCorners = _ref$roundedCorners === void 0 ? false : _ref$roundedCorners,
    _ref$displayIcon = _ref.displayIcon,
    displayIcon = _ref$displayIcon === void 0 ? true : _ref$displayIcon,
    rest = _objectWithoutProperties(_ref, _excluded$1);
  if (_isEmpty(src)) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: clsx(styles.image_preview_holder, roundedCorners && styles.rounded_corners)
    }, rest), displayIcon && /*#__PURE__*/React.createElement(PictureIcon, {
      size: "lg",
      className: styles.image_icon_holder
    }), /*#__PURE__*/React.createElement(CaptionText, {
      className: clsx(displayIcon && styles.image_text_holder)
    }, content.holderText));
  }
  return /*#__PURE__*/React.createElement("img", _extends({
    className: clsx(roundedCorners && styles.rounded_corners),
    src: src,
    "aria-hidden": ariaHidden
  }, rest));
};
Image.propTypes = {
  src: PropTypes.string,
  content: PropTypes.shape({
    holderText: PropTypes.string
  }),
  ariaHidden: PropTypes.bool,
  roundedCorners: PropTypes.bool,
  displayIcon: PropTypes.bool
};

var _excluded = ["src", "style"];
var BannerImage = function BannerImage(_ref) {
  var src = _ref.src,
    style = _ref.style,
    rest = _objectWithoutProperties$1(_ref, _excluded);
  var containerStyle = _objectSpread2({
    height: '10rem'
  }, style);
  var imageStyles = _objectSpread2({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    maxHeight: 200
  }, style);
  return /*#__PURE__*/React.createElement(Image, _extends$1({
    src: src,
    style: !src ? containerStyle : imageStyles
  }, rest));
};
BannerImage.propTypes = {
  src: PropTypes.string,
  style: PropTypes.object,
  theme: PropTypes.string
};

export { BannerImage };
